// Flappy Duck — tap to flap, thread every pipe.
export function createFlappy(host) {
  const { ctx, input } = host; const W = host.W, H = host.H;
  const GAP = 150, PIPE_W = 54, gravity = 1400, flap = -390, bx = W * 0.3;
  let y, vy, pipes, started;
  const addPipe = (x) => pipes.push({ x, gy: 60 + Math.random() * (H - GAP - 130), passed: false });
  const reset = () => { y = H / 2; vy = 0; pipes = []; started = false; addPipe(W + 40); addPipe(W + 40 + W * 0.6); };
  reset();
  return {
    dim: "2d", w: W, h: H, controls: ["a"], score: 0, over: false,
    frame(dt) {
      if (input.taps.includes("a") || input.taps.includes("up")) { vy = flap; started = true; host.sfx.click?.(); }
      if (!started) { y = H / 2 + Math.sin(performance.now() / 300) * 8; }
      else {
        vy += gravity * dt; y += vy * dt;
        pipes.forEach((p) => (p.x -= 165 * dt));
        if (pipes[0].x < -PIPE_W) { pipes.shift(); addPipe(pipes[pipes.length - 1].x + W * 0.6); }
        for (const p of pipes) if (!p.passed && p.x + PIPE_W < bx) { p.passed = true; this.score += 1; host.sfx.coin?.(); }
        for (const p of pipes) if (bx + 15 > p.x && bx - 15 < p.x + PIPE_W && (y - 15 < p.gy || y + 15 > p.gy + GAP)) { this.over = true; host.sfx.hit?.(); }
        if (y > H - 14 || y < 0) this.over = true;
      }
      ctx.fillStyle = "#0ea5e9"; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = "#7dd3fc"; for (let i = 0; i < 4; i++) { ctx.beginPath(); ctx.arc((i * 130 + (performance.now() / 40) % 520) - 40, 70 + i * 34, 24, 0, 7); ctx.fill(); }
      ctx.fillStyle = "#22c55e"; pipes.forEach((p) => { ctx.fillRect(p.x, 0, PIPE_W, p.gy); ctx.fillRect(p.x, p.gy + GAP, PIPE_W, H - p.gy - GAP); });
      ctx.fillStyle = "#166534"; pipes.forEach((p) => { ctx.fillRect(p.x - 4, p.gy - 16, PIPE_W + 8, 16); ctx.fillRect(p.x - 4, p.gy + GAP, PIPE_W + 8, 16); });
      ctx.save(); ctx.translate(bx, y); ctx.rotate(Math.max(-0.5, Math.min(1, vy / 500)));
      ctx.fillStyle = "#fbbf24"; ctx.beginPath(); ctx.arc(0, 0, 16, 0, 7); ctx.fill();
      ctx.fillStyle = "#f97316"; ctx.fillRect(12, -2, 9, 5);
      ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(5, -6, 4, 0, 7); ctx.fill(); ctx.fillStyle = "#000"; ctx.beginPath(); ctx.arc(6, -6, 2, 0, 7); ctx.fill();
      ctx.restore();
    },
  };
}
